// services/symptomService.js
import axiosInstance from "./AxiosInstance";

export function getSymptoms(pagination, pageid,search_by = "", search_keyword = "", sort_by = "",sort_order = "") {
  return axiosInstance.post("/admin/symptomList", { pagination, pageid ,search_by, search_keyword, sort_by, sort_order});
}

export function createSymptom(symptomData) {
  const disease_medicines_payload = Array.isArray(symptomData.disease_medicines)
    ? JSON.stringify(symptomData.disease_medicines)
    : symptomData.disease_medicines || "";

  return axiosInstance.post("/admin/addSymptom", {
    symptom_name: symptomData.symptomName,
    symptom_description: symptomData.description,
    symptom_status: symptomData.status,
    diseases_ids: symptomData.diseases_ids || "",
    disease_medicines: disease_medicines_payload,
  });
}

export function updateSymptom(symptomData, symptomId) {
  const disease_medicines_payload = Array.isArray(symptomData.disease_medicines)
    ? JSON.stringify(symptomData.disease_medicines)
    : symptomData.disease_medicines || "";

  return axiosInstance.post(`/admin/editSymptom`, {
    symptom_name: symptomData.symptomName,
    symptom_description: symptomData.description,
    symptom_status: symptomData.status,
    symptom_id: symptomId,
    diseases_ids: symptomData.diseases_ids || "",
    disease_medicines: disease_medicines_payload,
  });
}

export function deleteSymptom(symptom_id) {
  return axiosInstance.post(`/admin/deleteSymptom`, symptom_id);
}

export function formatSymptoms(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((symptom) => ({
      ...symptom,
      symptom_id: symptom.symptom_id || symptom._id || symptom.id,
    }));
  }

  let symptoms = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      symptoms.push({
        ...responseData[key],
        symptom_id:
          responseData[key].symptom_id ||
          responseData[key]._id ||
          responseData[key].id ||
          key,
      });
    }
  }
  return symptoms;
}
